import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Publish } from "@material-ui/icons"
import {
   getStorage,
   ref,
   uploadBytesResumable,
   getDownloadURL,
} from "firebase/storage"
import app from "../../firebase"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import Checkbox from "../../components/Checkbox/Checkbox"
// Data
import { updateServiceRequest, getUsers } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   WideBox,
   BoxTitle,
   StyledForm,
   FormItem,
   StyledLabel,
   StyledInput,
   StyledSelect,
   StyledOption,
   StyledTextArea,
   GeneralInfo,
   ButtonContainer,
   ButtonWrapper,
   StyledButton,
   Message,
   TitleWrapper,
   Title,
   Display,
   InfoItem,
   Column,
   Info,
   Upload,
   UpdateImage,
   UploadIcon,
} from "./ServiceRequest.styles"

const ServiceRequest = () => {
   const { requestId } = useParams()
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")
   const [requestInputs, setRequestInputs] = useState({})
   const request = useSelector((state) =>
      state.service.requests.find(
         (request) => request._id.toString() === requestId
      )
   )

   const user = useSelector((state) =>
      state.user.users.find((user) => user._id.toString() === request.userId)
   )

   useEffect(() => {
      if (typeof request === "object" && request !== null) {
         setRequestInputs({ ...request })
      }
   }, [request])

   useEffect(() => {
      getUsers(dispatch)
   }, [dispatch])

   const [sent, setSent] = useState(request.replacementSent)
   const sentChange = () => {
      setRequestInputs((prev) => {
         return {
            ...prev,
            replacementSent: !sent,
         }
      })
      setSent((current) => !current)
   }

   const [returned, setReturned] = useState(request.returnOk)
   const returnedChange = () => {
      setRequestInputs((prev) => {
         return {
            ...prev,
            returnOk: !returned,
         }
      })
      setReturned((current) => !current)
   }

   const [invoiced, setInvoiced] = useState(request.invoiced)
   const invoicedChange = () => {
      setRequestInputs((prev) => {
         return {
            ...prev,
            invoiced: !invoiced,
         }
      })
      setInvoiced((current) => !current)
   }

   const [credited, setCredited] = useState(request.credited)
   const creditedChange = () => {
      setRequestInputs((prev) => {
         return {
            ...prev,
            credited: !credited,
         }
      })
      setCredited((current) => !current)
   }

   const handleChange = (e) => {
      setRequestInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const res = await updateServiceRequest(
         requestInputs._id,
         {
            ...requestInputs,
         },
         dispatch
      )
      if (res === "success") {
         navigate("/services")
      } else {
         setErrorMessage(JSON.stringify(res))
      }
   }

   const handleImages = (e) => {
      e.preventDefault()
      const storage = getStorage(app)
      let storageRef
      let files = Array.from(e.target.files)
      let fileName = ""
      let imagesURL = []

      for (let i = 0; i < files.length; i++) {
         fileName = "RQ-SV-" + request.requestNumber + "_" + i

         storageRef = ref(storage, `Service/${fileName}`)
         const uploadTask = uploadBytesResumable(storageRef, files[i])

         uploadTask.on(
            "state_changed",
            (snapshot) => {
               const progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
               console.log("Upload is " + progress + "% done")
               switch (snapshot.state) {
                  case "paused":
                     console.log("Upload is paused")
                     break
                  case "running":
                     console.log("Upload is running")
                     break
                  default:
               }
            },
            (error) => {
               console.log(error)
            },
            () => {
               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                  console.log("File available at", downloadURL)
                  imagesURL.push(downloadURL)
               })
            }
         )
      }
      setRequestInputs({ ...requestInputs, images: imagesURL })
   }

   const deleteImages = (e) => {
      e.preventDefault()
      setRequestInputs({ ...requestInputs, images: [] })
   }

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Edit Service Request</Title>
               </TitleWrapper>
               <Display>
                  <Column>
                     <InfoItem>
                        <StyledLabel>Number :</StyledLabel>
                        <Info>{request.requestNumber}</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>ID :</StyledLabel>
                        <Info>{request._id}</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>Creation :</StyledLabel>
                        <Info>{request.createdAt}</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>Update :</StyledLabel>
                        <Info>{request.updatedAt}</Info>
                     </InfoItem>
                  </Column>
                  <Column>
                     <InfoItem>
                        <StyledLabel>User :</StyledLabel>
                        <Info>{user.username}</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>Company :</StyledLabel>
                        <Info>{user.companyName}</Info>
                     </InfoItem>
                     <InfoItem>
                        <StyledLabel>Customer :</StyledLabel>
                        <Info>{user.customerCode}</Info>
                     </InfoItem>
                  </Column>
               </Display>
               <WideBox>
                  <BoxTitle>Edit</BoxTitle>
                  <StyledForm>
                     <GeneralInfo>
                        <FormItem>
                           <StyledLabel>Request Date</StyledLabel>
                           <StyledInput
                              type="date"
                              name="requestDate"
                              value={requestInputs.requestDate?.split("T")[0]}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Spare Part</StyledLabel>
                           <StyledSelect
                              name="sparePart"
                              id="sparePart"
                              value={requestInputs.sparePart}
                              onChange={handleChange}
                           >
                              <StyledOption value="full">
                                 Full frame
                              </StyledOption>
                              <StyledOption value="temples">
                                 Both temples
                              </StyledOption>
                              <StyledOption value="left">
                                 Left temple
                              </StyledOption>
                              <StyledOption value="right">
                                 Right temple
                              </StyledOption>
                              <StyledOption value="endtips">
                                 End tips
                              </StyledOption>
                              <StyledOption value="nosepads">
                                 Nosepads
                              </StyledOption>
                           </StyledSelect>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Product Ref</StyledLabel>
                           <StyledInput
                              type="text"
                              name="productRef"
                              value={requestInputs.productRef}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Comments</StyledLabel>
                           <StyledTextArea
                              name="comments"
                              value={requestInputs.comments}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Images</StyledLabel>
                           <Upload>
                              {requestInputs.images?.map((img, index) => (
                                 <UpdateImage
                                    key={img}
                                    src={requestInputs.images[index]}
                                 />
                              ))}
                              <StyledLabel htmlFor="imagesURL">
                                 <UploadIcon>
                                    <Publish />
                                 </UploadIcon>
                              </StyledLabel>
                              <StyledInput
                                 type="file"
                                 id="imagesURL"
                                 name="imagesURL"
                                 style={{ display: "none" }}
                                 multiple
                                 onChange={(e) => handleImages(e)}
                              />
                           </Upload>
                           <StyledButton onClick={(e) => deleteImages(e)}>
                              Remove images
                           </StyledButton>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={requestInputs.replacementSent}
                                 onChange={sentChange}
                              />
                              Sent
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Date Replacement Shipped</StyledLabel>
                           <StyledInput
                              type="date"
                              name="dateReplacementShipped"
                              value={
                                 requestInputs.dateReplacementShipped?.split(
                                    "T"
                                 )[0]
                              }
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Carrier URL</StyledLabel>
                           <StyledInput
                              type="text"
                              name="carrierUrl"
                              value={requestInputs.carrierUrl}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={requestInputs.returnOk}
                                 onChange={returnedChange}
                              />
                              Return ok
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Date Return Received</StyledLabel>
                           <StyledInput
                              type="date"
                              name="dateReturnReceived"
                              value={
                                 requestInputs.dateReturnReceived?.split("T")[0]
                              }
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={requestInputs.invoiced}
                                 onChange={invoicedChange}
                              />
                              Invoiced
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Invoice Date</StyledLabel>
                           <StyledInput
                              type="date"
                              name="invoicedDate"
                              value={requestInputs.invoicedDate?.split("T")[0]}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Invoice Number</StyledLabel>
                           <StyledInput
                              type="text"
                              name="invoiceNumber"
                              value={requestInputs.invoiceNumber}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Invoice Amount</StyledLabel>
                           <StyledInput
                              type="number"
                              name="invoiceAmount"
                              value={requestInputs.invoiceAmount}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={request.credited}
                                 onChange={creditedChange}
                              />
                              Credited
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Credit Note Date</StyledLabel>
                           <StyledInput
                              type="date"
                              name="creditNoteDate"
                              value={
                                 requestInputs.creditNoteDate?.split("T")[0]
                              }
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Credit Note Number</StyledLabel>
                           <StyledInput
                              type="text"
                              name="creditNoteNumber"
                              value={requestInputs.creditNoteNumber}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Credit Note Amount</StyledLabel>
                           <StyledInput
                              type="number"
                              name="creditNoteAmount"
                              value={requestInputs.creditNoteAmount}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Product Id</StyledLabel>
                           <StyledInput
                              type="text"
                              name="productId"
                              defaultValue={requestInputs.productId}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Product Code</StyledLabel>
                           <StyledInput
                              type="text"
                              name="productCode"
                              value={requestInputs.productCode}
                              onChange={handleChange}
                           />
                        </FormItem>
                     </GeneralInfo>
                  </StyledForm>
               </WideBox>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Update</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default ServiceRequest
